import { render, staticRenderFns } from "./form-tag-list.vue?vue&type=template&id=84e800fe&"
import script from "./form-tag-list.vue?vue&type=script&lang=ts&"
export * from "./form-tag-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports